/* ZONLIDOOG: separar encabezados reales de la descripcion sin duplicar texto. */
if (!customElements.get('zd-product-disclosures')) {
  customElements.define('zd-product-disclosures', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.zdReady === 'true') return;
      this.dataset.zdReady = 'true';
      const fallback = this.querySelector('[data-zd-product-default]');
      const body = fallback && fallback.querySelector('[data-zd-product-body]');
      if (!fallback || !body) return;
      function sectionTitle(node) {
        if (node.nodeType !== 1) return '';
        const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text || text.length > 72) return '';
        const t = node.tagName;
        if (!/^H[1-6]$/.test(t) &&
            !(t === 'P' && /[:：]$/.test(text) && node.querySelector('strong,b'))) return '';
        return text.replace(/[:：\s]+$/, '').toLocaleUpperCase(document.documentElement.lang || 'es-ES');
      }
      function meaningful(node) {
        if (node.nodeType === 3) return Boolean(node.textContent.trim());
        return node.nodeType === 1 &&
          (Boolean(node.textContent.trim()) ||
           Boolean(node.matches('img,video,iframe,table,svg') ||
                   node.querySelector('img,video,iframe,table,svg')));
      }
      const fragment = document.createDocumentFragment();
      let title = this.dataset.defaultTitle || 'DESCRIPCIÓN';
      let nodes = [];
      let count = 0;
      const flush = () => {
        if (!nodes.some(meaningful)) { nodes = []; return; }
        const item = document.createElement('details');
        item.className = 'zd-product-disclosures__item';
        const summary = document.createElement('summary');
        summary.className = 'zd-product-disclosures__summary';
        const label = document.createElement('span');
        label.className = 'zd-product-disclosures__name';
        label.textContent = title;
        const icon = document.createElement('span');
        icon.className = 'zd-product-disclosures__chevron';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(label, icon);
        const content = document.createElement('div');
        content.className = 'zd-product-disclosures__body';
        nodes.forEach(n => content.appendChild(n));
        item.append(summary, content);
        fragment.appendChild(item);
        nodes = [];
        count++;
      };
      Array.from(body.childNodes).forEach(node => {
        const nextTitle = sectionTitle(node);
        if (nextTitle) {
          flush();
          title = nextTitle;
          node.remove();
        } else {
          nodes.push(node);
        }
      });
      flush();
      if (count > 0) fallback.replaceWith(fragment);
    }
  });
}